import { executePostRequest, FetchConfig } from '@api/client';
import { createAuthenticateApiPath } from '@routing/apiUrls';
import { AuthenticateMutation, AuthenticateResponse } from '@models/authenticate/Authenticate';

export const authenticate = async (mutation: AuthenticateMutation, config?: FetchConfig) => {
    const result = await executePostRequest<AuthenticateResponse>(createAuthenticateApiPath(mutation.tenantId), mutation, config);
    return result.data;
};
